import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { COMMENT_COUNT_DETAIL, COMMENT_COUNT_TABS } from 'Store/constants/sportTypes';

class Textarea extends Component {
  static propTypes = {
    value: PropTypes.string,
    required: PropTypes.bool,
    readOnly: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    id: PropTypes.string,
    autoFocus: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]),
    isFromTribun: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
  }
  constructor (props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidMount () {
    if (this.props.autoFocus) {
      this.refTextarea.focus();
    }
    this.props.isFromTribun && this.addEventListener();
  }

  componentWillUnmount () {
    this.props.isFromTribun && this.removeEventListener();
  }

  addEventListener () {
    this.refTextarea.addEventListener('keydown', e =>{
      this.handleTextArea(e, this.props);
    });
  }

  removeEventListener () {
    this.refTextarea.removeEventListener('keydown', this.handleTextArea);
  }

  handleChange = e => {
    const { value, onChange } = this.props;
    if (value.length > 0) {
      this.setState({
        hasError: false
      });
    }
    if (onChange) {
      onChange(e);
    }
  }

  handleTextArea (e, props) {
    const el = e.target;

    if (e.keyCode === 16 && e.shiftKey) {
      setTimeout(function () {
        el.style.cssText = 'height:auto; padding:0';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';
      }, 0);
      return;
    }
    if (e.keyCode === 13 && !e.shiftKey && el.value.trim()) {
      props.sendComment(props.item.feedId, el.value, props.tabType === 'coupon-detail' ? COMMENT_COUNT_DETAIL : COMMENT_COUNT_TABS, props.tabType);
      props.setComment();
      e.preventDefault();
    }
  }

  handleBlur = e => {
    const { required, value, onBlur } = this.props;
    if (required && value.length <= 0) {
      this.setState({
        hasError: true
      });
    } else {
      this.setState({
        hasError: false
      });
    }
    if ( onBlur ) {
      onBlur(e);
    }
    this.props.isFromTribun && this.removeEventListener();
  };

  render () {
    const textareaClass = classnames({
      'input--textarea': true,
      [this.props.className]: this.props.className,
      'input--textarea--error': this.state.hasError
    });
    return (
      <textarea
        id={ this.props.id }
        ref={ o => this.refTextarea = o }
        className={ textareaClass }
        onChange={ this.handleChange }
        value={ this.props.value }
        onBlur={ this.handleBlur }
        placeholder={ this.props.placeholder }
        maxLength={ this.props.maxLength }
        disabled={ this.props.disabled }
        onClick={ this.props.onClick }
      >{ this.props.value }</textarea>
    );
  }
}

export default Textarea;
